import * as firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/analytics'
import 'firebase/firestore'

const config = {
  apiKey: 'AIzaSyCP-e99Hv_EctBu98oB_dKz2L7Ftyi_qBM',
  authDomain: 'auth.tripply.dk',
  databaseURL: 'https://tripply-app.firebaseio.com',
  projectId: 'tripply-app',
  storageBucket: 'tripply-app.appspot.com',
  messagingSenderId: '783583676420',
  appId: '1:783583676420:web:1fd984067e115a046ccd51',
  measurementId: 'G-9H9VV20VL8'
}

const app = firebase.initializeApp(config)

export const db = firebase.firestore(app)
export const analytics = firebase.analytics(app)

export default firebase

